import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

function ProgressBarWithLabel(props) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100vw",
        background:
          "transparent linear-gradient(122deg, #000000 0%, #262626 100%) 0% 0% no-repeat padding-box",
      }}
    >
      <Box sx={{ width: "50%" }}>
        <Box
          sx={{
            minWidth: 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: "4rem",
              color: "#BDA770",
              mb: 4,
              fontFamily: "'TradeGothic LT', sans-serif",
              [theme.breakpoints.down("md")]: {
                fontSize: "2.5rem",
                mb: 0.7,
              },
            }}
          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            border: "solid #BDA77066 2px",
            padding: "5px",
            borderRadius: "4px",
          }}
        >
          <Box
            sx={{
              width: `${Math.round(props.value)}%`,
              backgroundColor: "#000000",
              backgroundImage:
                "linear-gradient( 90deg, #BDA770 25%, #221e1e 25%, transparent 50%, #000 50%, #221e1e 75%, #BDA770 75%, #BDA770 )",
              backgroundSize: "10px 20px",
              height: "50px",
              [theme.breakpoints.down("md")]: {
                height: "30px",
              },
            }}
          />
        </Box>
        <Box
          sx={{
            minWidth: 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 4,
            [theme.breakpoints.down("md")]: {
              mt: 1.6,
            },
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: "1.32rem",
              color: "#BDA770",
              fontFamily: "'Bodoni Std', sans-serif",
            }}
          >
            Loading...
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default function ProgressBar(e) {
  return (
    <Box sx={{ width: "100%" }}>
      <ProgressBarWithLabel value={e.value} />
    </Box>
  );
}
